import React from 'react'
import { Modal } from 'react-bootstrap'
import { COLOR_APP } from '../constants'
import "../pages/liveManage/liveScreen/liveScreen.css"

export default function ErrorPermissionModal({ showErrorPermissionModal, setShowErrorPermissionModal }) {
    return (
        <Modal
            show={showErrorPermissionModal}
            onHide={() => setShowErrorPermissionModal(false)}
            keyboard={false}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header
                style={{
                    background: "#e90000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: 50,
                    color: "#fff",
                }}
            >
                <h5>ທ່ານຕ້ອງເປີດອະນຸຍາດໃຫ້ເຂົ້າເຖິງຂໍ້ມູນເຫລົ່ານີ້ກ່ອນນຳໃຊ້</h5>
            </Modal.Header>
            <Modal.Body
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                }}
            >
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",
                }}>
                    <img src={"./images/permission1.JPG"} style={{ width: "36vw", height: "auto" }} />
                    <div style={{ width: 3 }} />
                    <img src={"./images/permission2.JPG"} style={{ width: "36vw", height: "auto" }} />
                </div>
                <div style={{ height: 3 }} />
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",
                }}>
                    <img src={"./images/permission3.JPG"} style={{ width: "36vw", height: "auto" }} />
                    <div style={{ width: 3 }} />
                    <img src={"./images/permission4.JPG"} style={{ width: "36vw", height: "auto" }} />
                </div>
            </Modal.Body>
        </Modal>
    )
}
